{% block swag_language_pack_settings_sales_channel %}
    <swag-language-pack-settings-base
        :isLoading="isLoading"
        :packLanguages="packLanguages"
        settingsType="salesChannel">
    </swag-language-pack-settings-base>
{% endblock %}
